import { Injectable } from '@angular/core';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor() { }

  showAlert(title: string, text: string, icon: SweetAlertIcon = 'info', confirmButtonText: string = 'OK'): void {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText
    });
  }

    async showAlertWithConfirm(title: string, text: string, icon: SweetAlertIcon = 'info', confirmButtonText: string = 'OK'): Promise<boolean> {
       return Swal.fire({
            title,
            text,
            icon,
            confirmButtonText
        }).then(result => result.isConfirmed);
    }

  async showConfirm(title: string, text: string, icon: SweetAlertIcon = 'warning', confirmButtonText: string = 'Yes', cancelButtonText: string = 'No'): Promise<boolean> {
    return Swal.fire({
      title,
      text,
      icon,
      showCancelButton: true,
      confirmButtonText,
      cancelButtonText,
      reverseButtons: false,
    }).then(result => result.isConfirmed);
  }

  showAlertforWarning(
    title: string,
    text: string,
    icon: SweetAlertIcon = 'info',
    confirmButtonText: string = 'OK'
  ): Promise<boolean> {
    return Swal.fire({
      title,
      text,
      icon,
      confirmButtonText
    }).then((result) => result.isConfirmed);
  }
  
}
